export enum MetadataOptions {
    String = 'string',
    Text = 'text',
    Radio = 'radio',
    Checkbox = 'checkbox',
    File = 'file',

    Date = 'date',
    Number = 'number',

}
export interface IMetadataJSON {
    key: string;
    propertyName: string;
    propertyType: string;
    fieldIsRequired?: boolean;
    propertyValue?: string;
}

export interface DropdownSelectorProps {
    onSelect?: (value: string) => MetadataOptions | void;
    value: MetadataOptions | string ;
}


export interface DatatypeSelectorProps<T = any> {
    inputType: MetadataOptions | string;
    label?: string | JSX.Element;
    value: MetadataOptions | string | any;
    onSelect?: (date: Date | string | null) => Date | string | null | void;
    width?: number,
    disabled?: boolean,
    extraDatatypeProps?: T[]
}


export interface MetadataFieldSelectorProps {
    getMetadata: (json: IMetadataJSON) => IMetadataJSON | void;
    metadata: IMetadataJSON;
    hideValues?: boolean
    hideBuilderControls?: boolean

}

export interface MetadataTemplateMakerProps {
    formFields: IMetadataJSON[];
    setFormFields: (json: IMetadataJSON[]) => IMetadataJSON[] | void;
    hideValues?: boolean
}

export interface TemplateElement {
    metadata: IMetadataJSON[];
    id: string | number
    name: string
}

export interface TemplateElementPicker {
    templateList: TemplateElement[];
    getTemplate?: (json: IMetadataJSON[]) => IMetadataJSON[] | void;
}


export interface RadioEntries { key: string, label: string }

export interface CheckBoxEntries extends RadioEntries {
    checked: boolean;
}
